import config from '../../assets/js/conf/config'
import request from '../../assets/js/utils/request'

const titleBase = config.baseApi + '/merchant/cloud/title-batch'
const shortTitleBase = config.baseApi + '/merchant/cloud/short-title-batch'
const skuPriceBase = config.baseApi + '/merchant/cloud/sku-price-batch'
const skuStockBase = config.baseApi + '/merchant/cloud/sku-stock-batch'
const productDeleteBase = config.baseApi + '/merchant/cloud/product-delete-batch'
const detailImageBase = config.baseApi + '/merchant/cloud/detail-image-batch'
const batchBase = config.baseApi + '/merchant/cloud/batch'
export const previewCloudTitleBatch = (data) =>
  request.get(titleBase + '/preview', {
    ...data,
    // GET 查询参数使用单一 JSON 字段，避免 Axios 将规则拆成 rules[] 字符串。
    rules: JSON.stringify(data.rules || [])
  })
export const createCloudTitleBatch = (data) => request.post(titleBase, data)
export const previewCloudShortTitleBatch = (data) => request.get(shortTitleBase + '/preview', data)
export const createCloudShortTitleBatch = (data) => request.post(shortTitleBase, data)
export const previewCloudSkuPriceBatch = (data) => request.post(skuPriceBase + '/preview', data)
export const previewCloudSkuPriceBatchSkus = (data) => request.post(skuPriceBase + '/sku-preview', data)
export const createCloudSkuPriceBatch = (data) => request.post(skuPriceBase, data)
export const previewCloudSkuStockBatch = (data) => request.post(skuStockBase + '/preview', data)
export const previewCloudSkuStockBatchSkus = (data) => request.post(skuStockBase + '/sku-preview', data)
export const createCloudSkuStockBatch = (data) => request.post(skuStockBase, data)
export const previewCloudProductDeleteBatch = (data) => request.post(productDeleteBase + '/preview', data)
export const previewCloudProductDeleteBatchSkus = (data) => request.post(productDeleteBase + '/sku-preview', data)
export const createCloudProductDeleteBatch = (data) => request.post(productDeleteBase, data)
export const previewCloudDetailImageBatch = (data) => request.post(detailImageBase + '/preview', data)
export const createCloudDetailImageBatch = (data) => request.post(detailImageBase, data)
export const getProductDetailImages = (productId) => request.get(config.baseApi + '/merchant/products/' + productId + '/detail-images')
export const saveProductDetailImages = (productId, data) => request.post(config.baseApi + '/merchant/products/' + productId + '/detail-images', data)
export const getCloudTitleBatchList = (data) => request.get(titleBase, data)
export const getCloudTitleBatchDetail = (id, data) => request.get(titleBase + '/' + id + '/details', data)
export const updateCloudTitleDetail = (id, data) => request.put(titleBase + '/details/' + id, data)
export const getCloudBatchList = (data) => request.get(batchBase, data)
export const getCloudBatchDetail = (id, data) => request.get(batchBase + '/' + id + '/details', data)
export const restoreCloudBatch = (id) => request.post(batchBase + '/' + id + '/restore')
